<template>
  <div class="flex content-section">
    <vk-offcanvas-content class="field-canvas">
      <vk-offcanvas flipped :show.sync="fieldConfig">
        <div class="flex">
          <vk-offcanvas-close @click="fieldConfig = false"></vk-offcanvas-close>
          <h3 class="font-medium text-lg">Gösterim Ayarları</h3>
        </div>
        <div v-if="fieldConfig" class="-medium-top">
          <vk-tabs align="justify">
            <vk-tabs-item title="Sıralama Kaydet">
              <form
                @submit.prevent="defaultSortSet()"
                class="flex border rounded-lg p-2 flex-col space-y-2"
              >
                <select v-model="sort.name" class="uk-select">
                  <option
                    v-for="fieldz in allFieldsFiltered"
                    class="uk-checkbox"
                    type="checkbox"
                    :value="fieldz"
                    :key="fieldz"
                    :disabled="fieldz == 'id'"
                  >
                    {{ getFieldDisplayName(fieldz) }}
                  </option>
                </select>
                <select v-model="sort.type" class="uk-select">
                  <option value="asc">Artan</option>
                  <option value="desc">Azalan</option>
                </select>
                <savebutton type="submit" title="Sıralayı kaydet" />
                <div class="text-xs">
                  Sıralamayı kaydettiğinizde listeleme sayfasında hep o sıralama
                  aktif olacaktır, bu ayar tarayıcınıza kayıt edilir.
                </div>
              </form>
            </vk-tabs-item>
            <vk-tabs-item title="Gösterim Düzeni">
              <vk-nav class="field-labels">
                <div class="flex mt-2 space-x-2">
                  <input
                    type="text"
                    placeholder="Arama"
                    class="uk-input rounded-lg "
                    v-model="fieldSearch"
                  />
                  <button class="green-button" @click="getData('Save')">
                    Kaydet
                  </button>
                </div>

                <label :key="field" v-for="field in allFieldsFiltered">
                  <input
                    class="uk-checkbox"
                    type="checkbox"
                    v-model="allFieldsCheckbox"
                    :value="field"
                    :disabled="field == 'id'"
                  />
                  {{ getFieldDisplayName(field) }}
                </label>
              </vk-nav>
            </vk-tabs-item>
            <vk-tabs-item
              v-if="allFieldsCheckbox"
              title="Gösterim Düzeni Sıralaması"
            >
              <button class="my-2 green-button w-full" @click="getData('Save')">
                Kaydet
              </button>

              <draggable v-model="allFieldsCheckbox" draggable=".drag">
                <div
                  :key="item"
                  class="
                    border-b
                    space-x-2
                    flex
                    items-center
                    justify-start
                    drag
                  "
                  v-for="item in allFieldsCheckbox"
                >
                  <div>
                    <vk-icon icon="list"></vk-icon>
                  </div>
                  <div>{{ getFieldDisplayName(item) }}</div>
                </div>
              </draggable>
            </vk-tabs-item>
          </vk-tabs>
        </div>
      </vk-offcanvas>
    </vk-offcanvas-content>

    <div class="w-full flex">
      <div
        v-if="sideBarShow"
        class="w-1/2 md:w-60 border-r absolute  md:relative bg-white z-20 md:-mt-4 pt-4  h-screen pr-2 text-sm mr-2"
      >
        <div class=" ">
          <form
            @submit="addFilters()"
            action="javascript:void(0)"
            class="flex flex-col space-y-2 w-full"
          >
            <div
              class="text-black flex justify-between items-center w-full font-medium"
            >
              <span class="flex-1">Detaylı Arama </span>
              <span
                class="md:opacity-0 block md:hidden float-right text-tile"
                @click="sideBarShow = false"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M17.414 16L24 9.414L22.586 8L16 14.586L9.414 8L8 9.414L14.586 16L8 22.586L9.414 24L16 17.414L22.586 24L24 22.586z"
                  />
                </svg>
              </span>
            </div>
            <template v-if="filters.length > 0">
              <div class="flex flex-col  items-start  text-sm my-2">
                <span
                  class="
              border-b
              flex
              justify-between
              space-x-2
              items-center 
              w-full 
              text-xs
              py-1 
            "
                  :key="filter.value"
                  v-for="filter in filters"
                >
                  <template v-if="fieldsMap[filter.name]">
                    <div class="flex space-x-2">
                      <span
                        class="
                        flex
                        items-center
                        space-y-2
                        flex-col
                        cursor-pointer
                        justify-center
                        filter-edit
                      "
                      >
                      <vk-icon
                          icon="pencil"
                          class="  hover:text-green-600"
                          ratio="0.6"
                          @click="filterEdit(filter)"
                        ></vk-icon>
                        <vk-icon
                          icon="close"
                          ratio="0.6"
                          class="hover:text-red-600"
                          @click="filterRemove(filter)"
                        ></vk-icon>
                      </span>

                      <b>{{ fieldsMap[filter.name].display_name }}</b>
                    </div>
                  </template>

                  <div class="flex space-x-2 items-center">
                    <span class="filter-label">
                      {{ filterTypeName(filter.type, filter.value, filter) }}
                    </span>
                    <span
                      class="
                        flex
                        items-center
                        cursor-pointer
                        justify-center
                        filter-close
                      "
                    >
                    </span>
                  </div>
                </span>
              </div>

              <VDropdown>
                <div
                  title="Filtreyi favorilere ekle"
                  class="text-tile inline-flex cursor-pointer border text-xs  items-center space-x-2 rounded-md border-tile-200 shadow-sm p-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 14 14"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="m9 13.5l-3.5-3l-3.5 3v-9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Z"
                      />
                      <path d="M5 .5h6a1 1 0 0 1 1 1v9" />
                    </g>
                  </svg>
                  <span>Aramayı favorilere ekle</span>
                </div>
                <!-- This will be the content of the popover -->
                <template #popper>
                  <form
                    @submit.prevent="favoriteFilter()"
                    class="p-2 text-xs flex space-x-2"
                  >
                    <input
                      type="text"
                      class="uk-input"
                      required
                      placeholder="Favori listeniz için bir isim"
                      v-model="favoriform.name"
                    />
                    <savebutton title="Kaydet" action="saveFormFavori" />
                  </form>
                </template>
              </VDropdown>
              <span v-if="filterForm.editedId" class="text-sm mb-2"
                >Arama Kriteri Düzeltme</span
              >
              <span v-else class="text-sm mb-2">Yeni Arama Kriteri</span>
            </template>

            <div v-if="fields">
              <select class="uk-select" v-model="filterForm.name">
                <option value="undefined" selected>Seçiniz</option>
                <option v-for="field in fields" :value="field.name" :key="field.name">
                  {{ field.display_name }}
                </option>
              </select>
            </div>

            <div>
              <select
                class="uk-select"
                v-if="fieldsMap[filterForm.name]"
                v-model="filterForm.type"
              >
                <option
                  :value="filterv.id"
                  :key="filterv.id"
                  v-for="filterv in filterTypes"
                >
                  {{ filterv.value }}
                </option>
              </select>
            </div>

            <template v-if="filterForm.name">
              <template v-if="filterForm.type == 11 || filterForm.type == 12">
                <search-item
                  :form="filterForm"
                  :multiple="true"
                  :value="filterForm.value"
                  :input="fieldsMap[filterForm.name]"
                  @changed="(returned) => (filterForm.value = returned.value)"
                  :type="fieldsMap[filterForm.name].component.name"
                />
              </template>
              <template
                v-else-if="
                  filterForm.type == 2 ||
                    filterForm.type == 3 ||
                    filterForm.type == 8 ||
                    filterForm.type == 9
                "
              >
                <input
                  type="text"
                  class="uk-input"
                  v-model="filterForm.value"
                  placeholder="Değer girin"
                />
              </template>
              <template v-else>
                <search-item
                  :form="filterForm"
                  :value="filterForm.value"
                  :input="fieldsMap[filterForm.name]"
                  @changed="(returned) => (filterForm.value = returned.value)"
                  :type="fieldsMap[filterForm.name].component.name"
                />
              </template>
            </template>

            <div class="flex space-x-2">
              <savebutton
                action="addFilters"
                v-if="filterForm.editedId"
                title="Güncelle"
              />
              <savebutton action="addFilters" v-else title="Ara" />
              <span
                class="global-button cursor-pointer"
                v-if="filterForm.editedId"
                @click="filterForm = []"
                >iptal</span
              >
            </div>
          </form>
        </div>

        <FavoriteFilters :table="table" />
      </div>

      <div class="flex-1">
        <div class="flex  flex-1 w-full items-start space-x-2">
          <div class="md:w-5/6 flex flex-wrap items-center gap-2 table-toolbar">
            <button @click="sideBarShow = !sideBarShow" class="">
              <span class="global-button" v-if="sideBarShow">
                <svg class="w-5 h-5" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="m14 18l-6-6l6-6l1.4 1.4l-4.6 4.6l4.6 4.6Z"
                  />
                </svg>
              </span>
              <span v-else class="global-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-5 h-5 text-tile-500"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="m19.6 21l-6.3-6.3q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.888T3 9.5q0-2.725 1.888-4.612T9.5 3q2.725 0 4.613 1.888T16 9.5q0 1.1-.35 2.075T14.7 13.3l6.3 6.3zM9.5 14q1.875 0 3.188-1.312T14 9.5q0-1.875-1.312-3.187T9.5 5Q7.625 5 6.313 6.313T5 9.5q0 1.875 1.313 3.188T9.5 14"
                  />
                </svg>
                <span class="hidden md:block">Detaylı Arama</span>
              </span>
            </button>

            <button @click="fieldConfigOpen()" class="global-button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-tile-500"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20zm9-2h2.5V6H13zm-4.5 0H11V6H8.5zM4 18h2.5V6H4zm13.5 0H20V6h-2.5z"
                />
              </svg>

              <span class="hidden md:block">Gösterim Ayarları</span>
            </button>

            <button
              @click="downloadExcel(false)"
              v-if="$root.cache.me.department == 'admin' || $root.cache.me.department == 'admin2'"
              class="global-button"
              title="Hızlı Export (Notlar Olmadan)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-tile-500"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20zm9-2h2.5V6H13zm-4.5 0H11V6H8.5zM4 18h2.5V6H4zm13.5 0H20V6h-2.5z"
                />
              </svg>

              <span class="hidden md:block">Export</span>
            </button>

            <button
              @click="downloadExcel(true)"
              v-if="$root.cache.me.department == 'admin' || $root.cache.me.department == 'admin2'"
              class="global-button"
              title="Notlu Export (Daha Yavaş)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-tile-500"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                />
              </svg>

              <span class="hidden md:block">Notlu Export</span>
            </button>

            <button
              class="global-button"
              @click="inlineInsertFormModal = !inlineInsertFormModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-tile-500"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M13 14h2v-3h3V9h-3V6h-2v3h-3v2h3zm-7 4V2h16v16zm2-2h12V4H8zm-6 6V6h2v14h14v2zM8 4v12z"
                />
              </svg>

              <span class="hidden md:block">Ekle</span>
            </button>

            <select
              @change="setLimit()"
              v-model="limit"
              class="uk-select"
              style="max-width: 70px"
            >
              <option value>Seçiniz</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="25">25</option><option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="250">250</option>
              <option value="500">500</option>
              <option v-if="permissions.delete == 1" value="2000">2000</option>
              <option v-if="permissions.delete == 1" value="5000">5000</option> 
            </select>

          </div>
          <div class="md:w-1/6 flex items-center justify-end gap-2 table-toolbar">
            <div v-if="permissions.excel_import == 1">
              <router-link :to="'/excel/' + table">
                <span
                  class=" global-button
            "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="m2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M4 4.735v14.53l10 1.429V3.306zM17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zm-6.8-7l2.8 4h-2.4L9 13.714L7.4 16H5l2.8-4L5 8h2.4L9 10.286L10.6 8H13z"
                    />
                  </svg>
                  <span class="hidden md:block">Excel Yükle</span>
                </span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Toplu işlem çubuğu: kayıt seçilince araç çubuğunun altında açılır -->
        <div v-if="selection.length > 0 && permissions" class="bulk-bar">
          <span class="bulk-bar-count">
            <strong>{{ selection.length }}</strong> kayıt seçili
          </span>

          <select v-model="bulkForm.type" class="uk-select bulk-bar-select">
            <option value>İşlem seçin</option>
            <option v-if="permissions.update == 1" value="1">Düzenle</option>
            <option v-if="permissions.delete == 1" value="2">Sil</option>
          </select>

          <template v-if="bulkForm.type == 1">
            <div class="bulk-field">
              <select
                v-model="bulkForm.fieldName"
                class="uk-select bulk-bar-select"
              >
                <option value>Alan seçin</option>
                <option
                  v-for="(name, fieldName) in tableHead"
                  :value="fieldName"
                  :key="fieldName"
                >
                  <template v-if="fieldsMap[name]">{{
                    fieldsMap[name].display_name
                  }}</template>
                </option>
              </select>
              <div v-if="isAssignmentField(bulkForm.fieldName)" class="assign-mode">
                <button
                  type="button"
                  :class="{ active: !distribution.enabled1 }"
                  @click="setDistribute(1, false)"
                >Tek kişiye</button>
                <button
                  type="button"
                  :class="{ active: distribution.enabled1 }"
                  title="Kayıtlar seçilen kişiler arasında eşit dağıtılır"
                  @click="setDistribute(1, true)"
                >Eşit dağıt</button>
              </div>
              <bulk-distribute-picker
                v-if="isDistributing(1)"
                v-model="distribution.users1"
                :options="assignmentOptions(bulkForm.fieldName)"
                :record-count="selection.length"
              />
              <span v-else-if="bulkForm.fieldName && fieldsMap[bulkForm.fieldName]">
                <form-item
                  :input="fieldsMap[bulkForm.fieldName]"
                  @changed="(g) => {
                    bulkForm.fieldValue = g.value;
                    bulkForm.fieldValueItem = Object.values($root.cache.getOptions[fieldsMap[bulkForm.fieldName].id]).find(e => e.value == g.value);
                  }"
                  :type="fieldsMap[bulkForm.fieldName].component.name"
                />
              </span>
            </div>

            <div v-if="bulkForm.doubleUpdate" class="bulk-field">
              <select
                v-model="bulkForm.fieldName2"
                class="uk-select bulk-bar-select"
              >
                <option value>İkinci alan</option>
                <option
                  v-for="(name, fieldName) in tableHead"
                  :value="fieldName"
                  :key="fieldName"
                >
                  <template v-if="fieldsMap[name]">{{
                    fieldsMap[name].display_name
                  }}</template>
                </option>
              </select>
              <div v-if="isAssignmentField(bulkForm.fieldName2)" class="assign-mode">
                <button
                  type="button"
                  :class="{ active: !distribution.enabled2 }"
                  @click="setDistribute(2, false)"
                >Tek kişiye</button>
                <button
                  type="button"
                  :class="{ active: distribution.enabled2 }"
                  title="Kayıtlar seçilen kişiler arasında eşit dağıtılır"
                  @click="setDistribute(2, true)"
                >Eşit dağıt</button>
              </div>
              <bulk-distribute-picker
                v-if="isDistributing(2)"
                v-model="distribution.users2"
                :options="assignmentOptions(bulkForm.fieldName2)"
                :record-count="selection.length"
              />
              <span v-else-if="bulkForm.fieldName2 && fieldsMap[bulkForm.fieldName2]">
                <form-item
                  :input="fieldsMap[bulkForm.fieldName2]"
                  @changed="(g) => {
                    bulkForm.fieldValue2 = g.value;
                    bulkForm.fieldValue2Item = Object.values($root.cache.getOptions[fieldsMap[bulkForm.fieldName2].id]).find(e => e.value == g.value);
                  }"
                  :type="fieldsMap[bulkForm.fieldName2].component.name"
                />
              </span>
            </div>

            <div class="bulk-checks">
              <label>
                <input type="checkbox" class="uk-checkbox" v-model="bulkForm.doubleUpdate" value="1" />
                İkili atama
              </label>
              <label
                v-if="(table == 'leads' || table == 'customers') && (bulkForm.fieldName == 'agent_id' || bulkForm.fieldName2 == 'agent_id')"
                title="Seçili kayıtların mevcut notları satışçılara gizlenecektir"
              >
                <input type="checkbox" class="uk-checkbox" v-model="bulkForm.hide_notes" value="1" />
                Notları gizleyerek ata
              </label>
            </div>

            <div v-if="bulkForm.fieldName" class="bulk-actions">
              <button @click="bulkUpdate()" type="submit" class="primary-button">
                Uygula
              </button>
              <button
                @click="bulkUpdateAll()"
                type="submit"
                v-if="permissions.update == 1 && $root.cache.me.department == 'admin'"
                title="Mevcut filtrelere göre tüm kayıtları arka planda günceller"
                class="global-button"
              >
                Tümünü Güncelle
              </button>
            </div>
          </template>

          <div v-if="bulkForm.type == 2" class="bulk-actions">
            <button @click="bulkRemove()" type="submit" class="global-button-red">
              Seçili olanları Sil
            </button>
            <button
              @click="bulkRemoveNotes()"
              type="submit"
              title="Lead ve müşteriye yazılmış notları topluca silmeyi sağlar"
              class="global-button"
            >
              Seçili Notları Sil
            </button>
            <button
              @click="bulkRemoveAll()"
              type="submit"
              v-if="permissions.delete == 1 && $root.cache.me.department == 'admin'"
              title="Mevcut filtrelere göre tüm kayıtları arka planda siler"
              class="global-button"
            >
              Tümünü Sil
            </button>
            <button
              @click="bulkRemoveAllNotes()"
              type="submit"
              v-if="permissions.delete == 1 && $root.cache.me.department == 'admin'"
              title="Mevcut filtrelere göre tüm notları arka planda siler"
              class="global-button"
            >
              Tüm Notları Sil
            </button>
          </div>
        </div>

        <template v-if="loading">
          <div class="root">
            <div class="no-results">
              <vk-spinner v-if="loading" ratio="4"></vk-spinner>
              <h2>Yükleniyor</h2>
              <h6>Yükleniyor lütfen bekleyin</h6>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="mt-4 min-h-screen rounded-lg">
            <form
              autocomplete="off"
              method="post"
              action="javascript:void(0)"
              @submit="multiSearch()"
            >
              <h3 class="total-records">
                Toplam Kayıt: {{ total }}
                <template v-if="page">, {{ page }} sayfa</template>
                <template v-if="selection">
                  <template v-if="selection.length > 0">
                    , Seçili kayıt sayısı: {{ selection.length }}
                  </template>
                </template>
              </h3>
              <table
                class="border rounded-lg uk-table uk-table-divider lead_table uk-table-hover"
              >
                <thead class="drop-shadow">
                  <tr class="drop-shadow">
                    <th class="thead-item  text-center mx-auto w-10">
                      <input
                        class="uk-checkbox"
                        type="checkbox"
                        v-model="select_all"
                        @click="selectAll(tableData)"
                      />
                    </th>
                    <th
                      class="thead-item"
                      :class="{ 'w-20': fieldName == 'ID' }"
                      :key="fieldName"
                      v-for="(name, fieldName) in tableHead"
                      @click="setSortItem(fieldName)"
                    >
                      <span class="flex items-center">
                        <template v-if="fieldName == sort.name">
                          <template v-if="fieldsMap[name]">
                            <span>{{ fieldsMap[name].display_name }}</span>
                          </template>
                          <template v-else>
                            <span>{{ name }}</span>
                          </template>

                          <template v-if="sort.type == 'desc'">
                            <vk-icon-link
                              reset
                              href="#"
                              icon="chevron-down"
                            ></vk-icon-link>
                          </template>
                          <template v-else>
                            <vk-icon-link
                              reset
                              href="#"
                              icon="chevron-up"
                            ></vk-icon-link>
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="fieldsMap[name]">
                            <span>{{ fieldsMap[name].display_name }}</span>
                          </template>
                          <template v-else>
                            <span>{{ name }}</span>
                          </template>
                        </template>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="in-table-search">
                    <td class="text-center p-4">
                      <button
                        type="submit"
                        style="
                    background: none;
                    border: none;
                    margin: 0px;
                    margin-top:10px;
                    padding: 0px;
                  "
                      >
                        <vk-icon icon="search" />
                      </button>
                    </td>
                    <th
                      :key="fieldName"
                      :class="{ 'w-4': fieldName == 'id' }"
                      v-for="(name, fieldName) in tableHead"
                    >
                      <template
                        v-if="
                          fieldsMap[fieldName] && fieldsMap[fieldName].component
                        "
                      >
                        <search-item
                          :form="multiFilterItem"
                          @changed="
                            (gelen) =>
                              multiFilterFormAdd(gelen.value, fieldName)
                          "
                          :label="false"
                          v-model="multiFilterItem[fieldName]"
                          :input="fieldsMap[fieldName]"
                          :type="fieldsMap[fieldName].component.name"
                        />
                      </template>
                    </th>
                  </tr>
                  <template v-if="total > 0">
                    <tr
                      v-for="data in tableData"
                      :key="data.id + ':' + (rowRevisions[data.id] || 0)"
                      :data-row-id="data.id"
                      :class="{
                        'quickview-row-active':
                          quickViewActiveId !== null &&
                          String(data.id) === quickViewActiveId,
                      }"
                    >
                      <td class="text-center">
                        <input
                          class="uk-checkbox"
                          type="checkbox"
                          v-model="selection"
                          :value="data.id"
                        />
                      </td>
                      <td
                        :class="{ 'w-4': fieldName == 'id' }"
                        v-for="(name, fieldName, index) in tableHead"
                        :key="index"
                      >
                        <row
                          :rowdata="data[fieldName]"
                          :rowall="data"
                          :fieldname="fieldName"
                          :table="table"
                          :inputs="fieldsMap[fieldName]"
                          :detailurl="detailurl"
                          :fieldtype="fieldName"
                        />
                      </td>
                    </tr>
                  </template>
                  <tr v-if="total == 0">
                    <td :colspan="Object.keys(tableHead).length + 1">
                      <div class="root">
                        <div class="no-results">
                          <svg
                            width="260"
                            height="140"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m188.93 118.333 19.063-12.415c2.031-1.317 3.263-3.562 3.247-5.949l-.147-24.706a6.8 6.8 0 0 0-3.32-5.803l-19.205-11.431c-2.27-1.351-5.146-1.29-7.404.165l-19.063 12.415c-2.031 1.318-3.263 3.562-3.247 5.949l.147 24.706a6.804 6.804 0 0 0 3.32 5.803l10.324 6.15 8.886 5.288c2.27 1.351 5.141 1.284 7.392-.167l.007-.005Z"
                              stroke="#99A2AF"
                              stroke-width="0.75"
                              stroke-miterlimit="10"
                            ></path>
                            <path
                              opacity="0.4"
                              d="M200.101 76.66 187.169 85c-1.55.976-3.54 1.016-5.09.09l-8.26-4.918-1.786-1.063-3.395-2.018-3.126-1.864a1.515 1.515 0 0 1-.754-1.315 1.579 1.579 0 0 1 .735-1.35l9.411-6.135-.005.023 7.071-4.607c1.53-.993 3.539-1.034 5.088-.108l15.253 9.085h-.03l1.299.768c.678.405.754 1.102.762 1.388.003.28-.064.983-.743 1.414l-3.519 2.283.021-.014Z"
                              stroke="#99A2AF"
                              stroke-width="0.75"
                              stroke-miterlimit="10"
                            ></path>
                            <g filter="url(#a)">
                              <rect
                                x="68.647"
                                y="17"
                                width="47.583"
                                height="47.583"
                                rx="9"
                                transform="rotate(45 68.647 17)"
                                stroke="#E16741"
                                stroke-width="0.75"
                              ></rect>
                            </g>
                            <rect
                              opacity="0.4"
                              x="68.647"
                              y="24.764"
                              width="36.602"
                              height="36.602"
                              rx="6"
                              transform="rotate(45 68.647 24.764)"
                              stroke="#E16741"
                              stroke-width="0.75"
                            ></rect>
                            <path
                              d="M71 44h-3.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C63 46.28 63 47.12 63 48.801v4.398c0 1.68 0 2.521.327 3.163a3 3 0 0 0 1.311 1.311C65.28 58 66.12 58 67.8 58h2.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C75 55.72 75 54.88 75 53.2V48m-4-4v2.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C71.76 48 72.04 48 72.6 48H75m-4-4 2 2 2 2"
                              stroke="#E16741"
                              stroke-width="0.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M94 25.017c13.861-7.838 30.626-10.65 47.354-6.637 16.729 4.013 30.394 14.124 39.191 27.397"
                              stroke="#E16741"
                              stroke-width="0.5"
                              stroke-linejoin="round"
                              stroke-dasharray="4 4"
                            ></path>
                            <path
                              opacity="0.5"
                              d="M66.914 95c8.927 13.186 22.691 23.162 39.459 27.01 16.767 3.848 33.504.871 47.286-7.104"
                              stroke="#99A2AF"
                              stroke-width="0.5"
                              stroke-linejoin="round"
                              stroke-dasharray="4 4"
                            ></path>
                          </svg>
                          <h2 class="text-lg font-semibold">
                            Kayıt Bulunamadı
                          </h2>
                          <h6 class="text-sm">
                            Kriterlerinize uyan bir kayıt bulunamadı
                          </h6>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 class="total-records">
                Toplam Kayıt: {{ total }}
                <template v-if="page">, {{ page }} sayfa</template>
              </h3>
            </form>
            <vk-pagination
              v-if="total > 0"
              :page.sync="page"
              v-on:update:page="onPageChange"
              :perPage="limit"
              :total="total"
            >
              <vk-pagination-page-prev></vk-pagination-page-prev>
              <vk-pagination-pages></vk-pagination-pages>
              <vk-pagination-page-next></vk-pagination-page-next>
            </vk-pagination>
          </div>
        </template>
      </div>
    </div>
    <vk-modal
      :stuck="true"
      class="editFormModal"
      :show.sync="inlineInsertFormModal"
    >
      <add-item
        :table="table"
        v-if="inlineInsertFormModal"
        type="insert"
        :inputs="fields"
        :header="'Ekle'"
        @after="
          getData('insert');
          inlineInsertFormModal = false;
        "
      />
    </vk-modal>

    <vk-modal :stuck="true" class="editFormModal" :show.sync="modalEditShow">
      <modal-edit
        :table="modalEdit.table"
        v-if="modalEditShow"
        :id="modalEdit.id"
      />
    </vk-modal>
    <vk-modal
      :stuck="true"
      class="permissionModal"
      :show.sync="modalPermissionShow"
    >
      <UserPermissionsVue
        :table="modalEdit.table"
        v-if="modalPermissionShow"
        :user_group="modalEdit.id"
      />
    </vk-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Row from "./Row";
import AddItemVue from "../Ui/AddItem.vue";
import httpService from "../../services/http";
import FormItemVue from "../Ui/FormItem.vue";
import SearchItemVue from "../Ui/SearchItem.vue";
import EventBus from "../Ui/EventBus";
import EditModalVue from "../../views/EditModal.vue";
import FavoriteFilters from "./FavoriteFilters";
import BulkDistributePicker from "./BulkDistributePicker.vue";
import { saveListContext as storeListContext } from "../../services/listContext";
import { escapeHtml } from "../../services/safeHtml";
import UserPermissionsVue from "../../views/UserPermissions";
export default {
  name: "data-table",
  props: {
    table: String,
    permissions: {
      type: [Array, Object],
      required: true
    },
    detailurl: String,
    tablename: String,
  },
  components: {
    Row,
    "form-item": FormItemVue,
    "search-item": SearchItemVue,
    draggable,
    "modal-edit": EditModalVue,
    "add-item": AddItemVue,
    UserPermissionsVue,
    FavoriteFilters,
    "bulk-distribute-picker": BulkDistributePicker,
  },
  provide() {
    // id hücresindeki hızlı görüntüleme ikonu, drawer'da önceki/sonraki ve
    // sayfa sonunda bir sonraki sayfaya geçiş için
    const currentPage = () => this.page || 1;
    const pageCount = () =>
      Math.max(1, Math.ceil(this.total / (1 * this.limit || 1)));
    return {
      leadQuickViewSource: {
        ids: () => this.tableData.map((row) => row.id),
        pageInfo: () => ({ page: currentPage(), pages: pageCount() }),
        canLoadPage: (step) =>
          step > 0 ? currentPage() < pageCount() : currentPage() > 1,
        // step 0: aynı sayfayı tazeler (filtreden düşen/eklenen kayıt kaymasını görmek için)
        loadPage: (step) => {
          const before = this.tableData;
          this.page = currentPage() + step;
          return this.getData("pageupdate").then(() => {
            // getData hatayı yutuyor; tablo değişmediyse eski id'leri döndürme
            if (this.tableData === before) {
              throw new Error("page not loaded");
            }
            return this.tableData.map((row) => row.id);
          });
        },
      },
    };
  },
  data() {
    return {
      quickViewActiveId: null,
      // Yerinde güncellenen satırların hücreleri yeniden kurulsun diye
      // (hücre bileşenleri değeri sadece ilk açılışta okuyor)
      rowRevisions: {},
      favoriform: {},
      bulkOperationCancelled:false,
      storedFilterSave: false,
      favoriFormSave: false,
      defautSortParams: {},
      filterName: null,
      tabId: null,
      multiFilterItem: [],
      modalEditShow: false,
      inlineInsertFormModal: false,
      modalPermissionShow: false,
      leadDetailModal: false,
      modalEdit: [],
      filterTypes: [
        { id: 1, value: "Eşit olan" },
        { id: 2, value: "İçeren" },
        { id: 3, value: "İçermeyen" },
        { id: 4, value: "Büyük olan" },
        { id: 5, value: "Küçük olan" },
        { id: 6, value: "Büyük ve eşit olan" },
        { id: 7, value: "Küçük ve eşit olan" },
        { id: 8, value: "ile başlayan" },
        { id: 9, value: "ile biten" },
        { id: 10, value: "Arasındakiler" },
        { id: 11, value: "Birden fazla seçim" },
        { id: 12, value: "Birden fazla hariç tut" },
      ],
      loading: false,
      fields: {},
      bulkForm: {},
      bulkFormnew: null,
      // Toplu agent/retention atamasında "Eşit dağıt" (1: ilk alan, 2: ikili atama alanı)
      distribution: { enabled1: false, enabled2: false, users1: [], users2: [] },
      // "Tümünü Güncelle" başlarken dondurulan dağıtım ve batch'ler boyunca biriken özet
      bulkDistribute: null,
      bulkDistributeOffset: 0,
      bulkDistributeSummary: {},
      fieldsMap: [],
      select_all: false,
      allFields: [],
      sideBarShow: false,
      fieldSearch: null,
      fieldConfig: false,
      page: null,
      limit: 15,
      total: 200,
      allFieldsCheckbox: [],
      sort: {
        type: "desc",
        name: "id",
      },
      filters: [],
      filterForm: {
        name: "",
        type: "",
        value: "",
      },
      tableHead: [],
      multiFilter: [],
      multiFilterStatus: false,
      tableData: [],
      selection: [],
      filterToEdit: null,
      processingBulkOperation: false,
      bulkOperationProgress: 0,
      bulkOperationTotal: 0,
      bulkOperationMessage: '',
      bulkOperationInterval: null,
    };
  },
  created() {
    this.localStorageGet();

    // Parse URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    let queryParams = false;

    // Check for search query parameter
    if (this.$route.query.q) {
      this.filters = [{ type: 2, name: "name", value: this.$route.query.q }];
      queryParams = true;
    }

    // Parse pagination parameters
    if (urlParams.has('page')) {
      this.page = parseInt(urlParams.get('page'));
      queryParams = true;
    }

    if (urlParams.has('limit')) {
      this.limit = parseInt(urlParams.get('limit'));
      queryParams = true;
    }

    // Parse sorting parameters
    if (urlParams.has('sort_by') && urlParams.has('sort_type')) {
      this.sort = {
        name: urlParams.get('sort_by'),
        type: urlParams.get('sort_type')
      };
      queryParams = true;
    }

    // Parse filter parameters
    const filterParams = {};
    urlParams.forEach((value, key) => {
      if (key.startsWith('filter_')) {
        const parts = key.split('_');
        const filterIndex = parts[1];
        const filterPart = parts[2];
        
        if (!filterParams[filterIndex]) {
          filterParams[filterIndex] = {};
        }
        
        if (filterPart === 'name') {
          filterParams[filterIndex].name = value;
        } else if (filterPart === 'type') {
          filterParams[filterIndex].type = parseInt(value);
        } else if (filterPart === 'value') {
          filterParams[filterIndex].value = value;
        } else if (filterPart === 'value_start') {
          if (!filterParams[filterIndex].value) {
            filterParams[filterIndex].value = {};
          }
          filterParams[filterIndex].value.start = value;
        } else if (filterPart === 'value_end') {
          if (!filterParams[filterIndex].value) {
            filterParams[filterIndex].value = {};
          }
          filterParams[filterIndex].value.end = value;
        } else if (filterPart.startsWith('value_') && parts[3]) {
          // Handle array values
          if (!filterParams[filterIndex].value) {
            filterParams[filterIndex].value = [];
          }
          filterParams[filterIndex].value.push(value);
        }
      }
    });

    // Convert the filter params object to an array
    if (Object.keys(filterParams).length > 0) {
      Object.values(filterParams).forEach(filter => {
        if (filter.name && filter.type !== undefined) {
          this.filters.push(filter);
          
          // Also update multiFilterItem for the UI
          if (typeof filter.value === 'string' || typeof filter.value === 'number') {
            this.multiFilterItem[filter.name] = filter.value;
          }
        }
      });
      queryParams = true;
    }

    // For backward compatibility with the previous implementation
    urlParams.forEach((value, key) => {
      // Only process parameters that are not already processed
      if (!key.startsWith('filter_') && !key.startsWith('sort_') && key !== 'page' && key !== 'limit' && key !== 'q') {
        this.multiFilterItem[key] = value;
        
        // Try to determine if the value is a number
        const numValue = Number(value);
        if (!isNaN(numValue) && value.trim() !== '') {
          this.filters.push({ type: 1, name: key, value: numValue });
        } else {
          this.filters.push({ type: 2, name: key, value: value });
        }
        
        queryParams = true;
      }
    });

    if (queryParams) {
      this.getData("multiSearch");
    } else {
      this.getData("created");
    }
  },

  watch: {
    // Lead kartındaki "sonraki" düğmesi bu listenin filtre + sıralamasını izler.
    // Eskiden sadece filtre değişince yazılıyordu; sadece sıralamayı değiştiren
    // kullanıcı karta eski sıralamayla gidiyordu.
    filters: {
      deep: true,
      handler() {
        this.saveListContext();
      },
    },
    sort: {
      deep: true,
      handler() {
        this.saveListContext();
      },
    },
    $route(to) {
      this.routeCleaner();
      
      // Parse URL parameters
      const urlParams = new URLSearchParams(to.query);
      let queryParams = false;

      // Check for search query parameter
      if (to.query.q) {
        this.filters = [{ type: 2, name: "name", value: to.query.q }];
        queryParams = true;
      }

      // Parse pagination parameters
      if (urlParams.has('page')) {
        this.page = parseInt(urlParams.get('page'));
        queryParams = true;
      }

      if (urlParams.has('limit')) {
        this.limit = parseInt(urlParams.get('limit'));
        queryParams = true;
      }

      // Parse sorting parameters
      if (urlParams.has('sort_by') && urlParams.has('sort_type')) {
        this.sort = {
          name: urlParams.get('sort_by'),
          type: urlParams.get('sort_type')
        };
        queryParams = true;
      }

      // Parse filter parameters
      const filterParams = {};
      urlParams.forEach((value, key) => {
        if (key.startsWith('filter_')) {
          const parts = key.split('_');
          const filterIndex = parts[1];
          const filterPart = parts[2];
          
          if (!filterParams[filterIndex]) {
            filterParams[filterIndex] = {};
          }
          
          if (filterPart === 'name') {
            filterParams[filterIndex].name = value;
          } else if (filterPart === 'type') {
            filterParams[filterIndex].type = parseInt(value);
          } else if (filterPart === 'value') {
            filterParams[filterIndex].value = value;
          } else if (filterPart === 'value_start') {
            if (!filterParams[filterIndex].value) {
              filterParams[filterIndex].value = {};
            }
            filterParams[filterIndex].value.start = value;
          } else if (filterPart === 'value_end') {
            if (!filterParams[filterIndex].value) {
              filterParams[filterIndex].value = {};
            }
            filterParams[filterIndex].value.end = value;
          } else if (filterPart.startsWith('value_') && parts[3]) {
            // Handle array values
            if (!filterParams[filterIndex].value) {
              filterParams[filterIndex].value = [];
            }
            filterParams[filterIndex].value.push(value);
          }
        }
      });

      // Convert the filter params object to an array
      if (Object.keys(filterParams).length > 0) {
        Object.values(filterParams).forEach(filter => {
          if (filter.name && filter.type !== undefined) {
            this.filters.push(filter);
            
            // Also update multiFilterItem for the UI
            if (typeof filter.value === 'string' || typeof filter.value === 'number') {
              this.multiFilterItem[filter.name] = filter.value;
            }
          }
        });
        queryParams = true;
      }

      // For backward compatibility with the previous implementation
      urlParams.forEach((value, key) => {
        // Only process parameters that are not already processed
        if (!key.startsWith('filter_') && !key.startsWith('sort_') && key !== 'page' && key !== 'limit' && key !== 'q') {
          this.multiFilterItem[key] = value;
          
          // Try to determine if the value is a number
          const numValue = Number(value);
          if (!isNaN(numValue) && value.trim() !== '') {
            this.filters.push({ type: 1, name: key, value: numValue });
          } else {
            this.filters.push({ type: 2, name: key, value: value });
          }
          
          queryParams = true;
        }
      });

      if (queryParams) {
        this.getData("routeChange");
      } else {
        this.getData("watch");
      }
    },
    allFieldsCheckbox(data) {
      localStorage.setItem(this.table + "_allFieldsCheckbox", data);
    },
  },

  computed: {
    tableFieldsArray() {
      return this.tableHead;
    },
    allFieldsFiltered() {
      if (this.fieldSearch) {
        return Object.keys(this.allFields).filter((post) => {
          return post.toLowerCase().includes(this.fieldSearch.toLowerCase());
        });
      } else {
        return this.allFields;
      }
    },
  },
  methods: {
    saveListContext() {
      storeListContext(this.table + "_filters", {
        filters: this.filters,
        sort: this.sort,
      });
    },
    downloadExcel(withNotes = false) {
  EventBus.$emit("bottomMessage", {
    open: true,
    type: "info",
    title: withNotes ? "Notlu export hazırlanıyor..." : "Lütfen bekleyin",
    duration: 2000,
    body: withNotes ? "Notlar dahil edildiği için biraz daha uzun sürebilir" : "Dosyalar hazırlanıyor lütfen bekleyin",
  });

  // Filtre parametrelerini hazırla
  let exportFilters = [...this.filters]; // Mevcut filtrelerin bir kopyasını al

  // Eğer tablo "customers" ise ve is_customer filtresi yoksa ekle
  if (this.table === "customers") {
    // is_customer filtresi zaten var mı kontrol et
    const isCustomerFilterExists = exportFilters.some(filter => filter.name === "is_customer");

    if (!isCustomerFilterExists) {
      // Eğer yoksa, is_customer filtresini ekle
      exportFilters.push({ name: "is_customer", type: 1, value: "1" });
    }
  }

  console.log(exportFilters, "filters", "with_notes:", withNotes);

  if (exportFilters && exportFilters.length > 0) {
    httpService
      .exportExcel(this.table, { filters: exportFilters, with_notes: withNotes })
      .then((response) => {
        if (response.data.success && response.data.excelFiles.length > 0) {
          // Dosya isimlerini birleştirerek tek bir string haline getir
          let fileList = response.data.excelFiles.join("\n");
          EventBus.$emit("bottomMessage", {
            open: true,
            type: "info",
            title: "Dosyalar hazır",
            body: fileList,
          });
        } else {
          alert("Dosya oluşturulamadı veya dosya yok.");
        }
      })
      .catch((error) => {
        console.error("İndirme hatası: ", error);
      });
  }
  else {
    EventBus.$emit("bottomMessage", {
      open: true,
      type: "info",
      title: "Filtreden veriler seçilmiş olmalıdır",
      duration: 2000,
      body: "Filtre boş olmamalı",
    });
  }
},
    favoriteFilterApply(data) {
      this.filters = data;
      this.getData("favoriteFilterApply");
    },
    favoriteFilter() {
      EventBus.$emit("loadingStatus", {
        action: "saveFormFavori",
        loading: true,
      });

      httpService
        .inlineSave({
          table: "favorite_filters",
          type: "insert",
          inputs: {
            name: this.favoriform.name,
            table: this.table,
            filters: JSON.stringify(this.filters),
          },
        })
        .then(() => {
          this.favoriFormSave = false;
          this.favoriform.name = null;
          EventBus.$emit("loadingStatus", {
            action: "saveFormFavori",
            loading: false,
            success: true,
          });
          EventBus.$emit("reflesh", true);
        });
    },
    multiSearch() {
      const urlBuild = new URL(
        window.location.origin + window.location.pathname
      );

      this.filters = [];
      Object.keys(this.multiFilterItem).map((mp) => {
        if (this.multiFilterItem[mp]) {
          if (Number.isInteger(this.multiFilterItem[mp])) {
            this.filters.push({
              name: mp,
              value: this.multiFilterItem[mp],
              type: 1,
            });
          } else {
            if (mp == "name" || mp == "body") {
              this.filters.push({
                name: mp,
                value: this.multiFilterItem[mp],
                type: 2,
              });
            } else {
              this.filters.push({
                name: mp,
                value: this.multiFilterItem[mp],
                type: 1,
              });
            }
          }

          urlBuild.searchParams.append(mp, this.multiFilterItem[mp]);
        }
      });
      history.pushState("", "", urlBuild.href);

      this.getData("multiSearch");
    },
    routeCleaner() {
      this.sort =  {
        type: "desc",
        name: "id",
      };
      this.localStorageGet();
      this.selection = [];
      this.page = null;
      this.filterForm = [];
      this.filters = [];
      this.fieldsMap = [];
      this.tableData = [];
      this.tableHead = [];
      this.bulkForm = {};
      this.resetDistribution();
      this.multiFilterItem = [];
    },
    getFieldDisplayName(key) {
      if (typeof this.fields === "object" && this.fields !== null) {
        let item = this.fields.find((e) => {
          return e.name == key;
        });

        if (item) {
          return item.display_name;
        }
      }
      return key;
    },
    filterTypeName(id, value, filter) {
      let returntext = "";
      if (this.filterTypes.find((e) => e.id == id)) {
        returntext += this.filterTypes.find((e) => e.id == id).value;
      }
      if (id == 10) {
        return returntext + " : " + value.start + " : " + value.end;
      } else {
        // Filter value'sunu label'a çevir
        const displayValue = this.getFilterDisplayValue(value, filter);
        return returntext + " : " + displayValue;
      }
    },
    getFilterDisplayValue(value, filter) {
      // filter yoksa veya name yoksa direkt value döndür
      if (!filter || !filter.name) {
        return value;
      }

      // fieldsMap'ten field bilgisini al
      const fieldInfo = this.fieldsMap[filter.name];
      if (!fieldInfo || !fieldInfo.id) {
        return value;
      }

      // Global options'dan label'ları çek
      const optionKey = fieldInfo.id;
      const options = this.$root.cache && this.$root.cache.getOptions && this.$root.cache.getOptions[optionKey];

      if (!options || !Array.isArray(options) || options.length === 0) {
        return value;
      }

      // Value array ise (multiple select)
      if (Array.isArray(value)) {
        const labels = value.map(id => {
          const option = options.find(opt => String(opt.value) === String(id));
          return option ? option.label : id;
        });
        return labels.join(', ');
      }

      // Value string ise ve virgül içeriyorsa (multiple select - string format)
      if (typeof value === 'string' && value.includes(',')) {
        const ids = value.split(',').map(id => id.trim());
        const labels = ids.map(id => {
          const option = options.find(opt => String(opt.value) === String(id));
          return option ? option.label : id;
        });
        return labels.join(', ');
      }

      // Tek değer için
      const option = options.find(opt => String(opt.value) === String(value));
      return option ? option.label : value;
    },
    isAssignmentField(name) {
      return (
        (this.table == "leads" || this.table == "customers") &&
        (name == "agent_id" || name == "retention_id")
      );
    },
    isDistributing(slot) {
      if (slot == 2 && !this.bulkForm.doubleUpdate) return false;
      const name = slot == 1 ? this.bulkForm.fieldName : this.bulkForm.fieldName2;
      return this.distribution["enabled" + slot] && this.isAssignmentField(name);
    },
    setDistribute(slot, enabled) {
      this.distribution["enabled" + slot] = enabled;
    },
    resetDistribution() {
      this.distribution = { enabled1: false, enabled2: false, users1: [], users2: [] };
    },
    // Dağıtım listesi, alanın tekli seçimdeki kendi kullanıcı seçenekleri
    assignmentOptions(fieldName) {
      const field = this.fieldsMap[fieldName];
      const options = field && this.$root.cache.getOptions[field.id];
      return Object.values(options || {})
        .filter((o) => Number(o.value) > 0)
        .map((o) => ({ id: Number(o.value), name: o.label }));
    },
    // { agent_id: [5, 8] } — sadece "Eşit dağıt" seçili alanlar; kişi seçilmemişse false
    distributionPayload() {
      const payload = {};
      for (const slot of [1, 2]) {
        if (!this.isDistributing(slot)) continue;
        const users = this.distribution["users" + slot];
        if (!users.length) return false;
        payload[slot == 1 ? this.bulkForm.fieldName : this.bulkForm.fieldName2] = [...users];
      }
      return payload;
    },
    // Döngü her seferinde aynı kişiden başlamasın; artan kayıt rastgele kişiye düşer
    randomDistributeOffset() {
      return Math.floor(Math.random() * 100000);
    },
    distributionUserName(field, id) {
      const option = this.assignmentOptions(field).find((o) => o.id == id);
      return option ? option.name : "#" + id;
    },
    mergeDistributionSummary(target, summary) {
      Object.keys(summary || {}).forEach((field) => {
        target[field] = target[field] || {};
        Object.keys(summary[field]).forEach((userId) => {
          target[field][userId] = (target[field][userId] || 0) + Number(summary[field][userId]);
        });
      });
      return target;
    },
    distributionSummaryText(summary) {
      return Object.keys(summary)
        .map((field) => {
          const items = Object.keys(summary[field]).map(
            (userId) => this.distributionUserName(field, userId) + ": " + summary[field][userId]
          );
          return this.getFieldDisplayName(field) + " → " + items.join(", ");
        })
        .join(" | ");
    },
    notifyDistribution(summary) {
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "info",
        title: "Kayıtlar eşit dağıtıldı",
        duration: 8000,
        body: this.distributionSummaryText(summary),
      });
    },
    // Onay modalında bir alanın nasıl güncelleneceğinin açıklaması
    bulkFieldDescription(slot, total) {
      const name = slot == 1 ? this.bulkForm.fieldName : this.bulkForm.fieldName2;
      const label = this.getFieldDisplayName(name);
      if (this.isDistributing(slot)) {
        const n = this.distribution["users" + slot].length;
        const min = Math.floor(total / n);
        const max = Math.ceil(total / n);
        // innerHTML ile gösteriliyor: alan adı / değer kaçışlanır.
        return `"${escapeHtml(label)}" alanı seçilen <strong>${n}</strong> kişi arasında eşit dağıtılacak (kişi başı ${min === max ? min : min + "–" + max} kayıt)`;
      }
      const item = slot == 1 ? this.bulkForm.fieldValueItem : this.bulkForm.fieldValue2Item;
      const value = item ? item.label : slot == 1 ? this.bulkForm.fieldValue : this.bulkForm.fieldValue2;
      return `"${escapeHtml(label)}" alanı "${escapeHtml(value)}" değeri ile güncellenecek`;
    },
    bulkUpdateDoneMessage() {
      const summary = this.bulkDistributeSummary;
      const counts = Object.keys(summary).map((field) => Object.values(summary[field]));
      if (!counts.length) return "Tüm kayıtlar başarıyla güncellendi.";
      const people = counts.map((c) => c.length).join(" / ");
      const all = [].concat(...counts);
      const min = Math.min(...all);
      const max = Math.max(...all);
      return `Tüm kayıtlar başarıyla güncellendi. ${people} kişiye eşit dağıtıldı (kişi başı ${min === max ? min : min + "–" + max} kayıt).`;
    },
    setLimit() {
      this.limit = parseInt(this.limit);
      this.getData("setLimit");
    },
    changedAction(e) {
      this.bulkForm.new = e;
    },
    bulkUpdate() {
      let updateState = true;
      this.bulkForm.ids = this.selection;
      this.bulkForm.table = this.table;
      if (this.bulkForm.doubleUpdate == true) {
        if (this.bulkForm.fieldName == this.bulkForm.fieldName2) {
          updateState = false;
          alert("Güncellenecek alanların ikiside aynı olmamalı");
        }
      }
      const distribute = this.distributionPayload();
      if (updateState && distribute === false) {
        updateState = false;
        alert("Eşit dağıtım için en az bir kişi seçin.");
      }
      if (updateState) {
        const data = { ...this.bulkForm };
        if (Object.keys(distribute).length) {
          data.distribute = distribute;
          data.distribute_offset = this.randomDistributeOffset();
        }
        this.loading = true;
        httpService
          .bulkSave(data)
          .then((resp) => {
            if (resp.data && resp.data.success === false) {
              alert(resp.data.message || "Güncelleme yapılamadı");
              return;
            }
            if (resp.data && resp.data.distribution) {
              this.notifyDistribution(resp.data.distribution);
            }
            setTimeout(() => {
              this.getData("bulkUpdate");
            }, 100);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    bulkRemove() {
      if (confirm("Silinen kayıt geri getirelemez eminmisiniz ?")) {
        this.bulkForm.ids = this.selection;
        this.bulkForm.table = this.table;
        this.loading = true;
        httpService
          .bulkRemove(this.bulkForm)
          .then(() => {
            setTimeout(() => {
              this.getData("bulkRemove");
            }, 100);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },  
    bulkRemoveNotes() {
      if (confirm("Silinen notlar geri getirelemez eminmisiniz ?")) {
        this.bulkForm.ids = this.selection;
        this.bulkForm.table = this.table;
        this.loading = true;
        httpService
          .bulkRemoveNotes(this.bulkForm)
          .then(() => {
            setTimeout(() => {
              this.getData("bulkRemove");
            }, 100);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },


bulkUpdateAll() {
  // Önce alan ve değer kontrolleri
  if (!this.bulkForm.fieldName || (!this.isDistributing(1) && !this.bulkForm.fieldValue && this.bulkForm.fieldValue !== 0 && this.bulkForm.fieldValue !== false)) {
    alert("Lütfen güncellenecek alan ve değer seçin.");
    return;
  }
  
  // İkili atama varsa kontrol et
  if (this.bulkForm.doubleUpdate) {
    if (!this.bulkForm.fieldName2 || (!this.isDistributing(2) && !this.bulkForm.fieldValue2 && this.bulkForm.fieldValue2 !== 0 && this.bulkForm.fieldValue2 !== false)) {
      alert("İkili atama seçildi. Lütfen ikinci alan ve değer seçin.");
      return;
    }
    
    // Aynı alan kontrolü
    if (this.bulkForm.fieldName === this.bulkForm.fieldName2) {
      alert("Güncellenecek alanların ikiside aynı olmamalı");
      return;
    }
  }

  if (this.distributionPayload() === false) {
    alert("Eşit dağıtım için en az bir kişi seçin.");
    return;
  }

  // Toplam kayıt sayısını al ve kullanıcıya göster
  this.loading = true;
  
  httpService
    .getData({
      table: this.table,
      filters: this.filters,
      countOnly: true
    })
    .then(response => {
      this.loading = false;
      
      if (response.data && response.data.total) {
        this.bulkOperationTotal = response.data.total;
        
        // Güncelleme onay modalını göster
        this.showUpdateConfirmation(response.data.total);
      } else {
        EventBus.$emit("bottomMessage", {
          open: true,
          type: "warning",
          title: "Uyarı",
          duration: 3000,
          body: "Güncellenecek kayıt bulunamadı.",
        });
      }
    })
    .catch(error => {
      this.loading = false;
      console.error("Kayıt sayısı alınamadı:", error);
      
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "error",
        title: "Hata",
        duration: 3000,
        body: "Toplam kayıt sayısı alınamadı.",
      });
    });
},

// Güncelleme onay modalını göster
showUpdateConfirmation(total) {
  // Modal HTML oluşturma
  const modalContainer = document.createElement('div');
  modalContainer.id = 'update-confirmation-modal';
  modalContainer.className = 'fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50';
  
  const modalContent = document.createElement('div');
  modalContent.className = 'bg-white rounded-lg shadow-xl w-full max-w-md mx-4 overflow-hidden';
  
  console.log(this.bulkForm,"bulkForm");
  // Güncellenecek alan(lar) ve değer(ler) bilgisini hazırla
  let updateInfo = this.bulkFieldDescription(1, total);
  
  if (this.bulkForm.doubleUpdate && this.bulkForm.fieldName2) {
    updateInfo += ` ve ${this.bulkFieldDescription(2, total)}`;
  }
  
  // Modal içeriği
  modalContent.innerHTML = `
    <div class="p-6">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-medium text-gray-900">Toplu Güncelleme</h3>
        <button id="modal-close" class="text-gray-400 hover:text-gray-500">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      <div class="text-sm text-gray-500 mb-4">
        Mevcut filtrelere göre toplam <strong>${total}</strong> kayıt güncellenecektir. Bu işlem arka planda gerçekleştirilecektir.<br><br>
        <div class="p-2 bg-blue-50 border border-blue-200 rounded text-blue-800">
          ${updateInfo}
        </div>
      </div>
      <div class="mt-6 flex justify-end space-x-3">
        <button id="modal-cancel" class="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
          İptal
        </button>
        <button id="modal-confirm" class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700">
          Güncelle
        </button>
      </div>
    </div>
  `;
  
  modalContainer.appendChild(modalContent);
  document.body.appendChild(modalContainer);
  
  // Modal butonlarına event listener ekle
  document.getElementById('modal-close').addEventListener('click', () => {
    document.getElementById('update-confirmation-modal').remove();
  });
  
  document.getElementById('modal-cancel').addEventListener('click', () => {
    document.getElementById('update-confirmation-modal').remove();
  });
  
  document.getElementById('modal-confirm').addEventListener('click', () => {
    document.getElementById('update-confirmation-modal').remove();

    // Dağıtım ayarı işlem boyunca sabit kalsın
    this.bulkDistribute = this.distributionPayload() || {};
    this.bulkDistributeOffset = this.randomDistributeOffset();
    this.bulkDistributeSummary = {};

    this.startBulkOperation('update');
    this.processBulkUpdate(null, 1000);
  });
},

// Toplu güncelleme işlemi sürecini başlat
// Sayfa numarası (OFFSET) yerine son işlenen id'den devam edilir: güncellenen alan
// filtrede de varsa kayıtlar filtreden çıkıp sonraki sayfalar öne kayıyor ve
// aradaki kayıtlar atlanıyordu. id < lastId filtresi PK index'ini kullanır.
processBulkUpdate(lastId, batchSize, processedCount = 0) {
  // İptal edildiyse işlemi durdur
  if (!this.processingBulkOperation || this.bulkOperationCancelled) return;

  const batchFilters = lastId
    ? [...this.filters, { name: 'id', type: 5, value: lastId }]
    : this.filters;

  httpService
    .getData({
      table: this.table,
      page: 1,
      limit: batchSize,
      sort: { name: 'id', type: 'desc' },
      filters: batchFilters,
      fields: ['id'] // Sadece ID'leri al
    })
    .then(response => {
      // İptal edildiyse devam etme
      if (this.bulkOperationCancelled) return;
      
      // Eğer bu sayfada kayıt varsa
      if (response.data && response.data.results && response.data.results.length > 0) {
        const ids = response.data.results.map(item => item.id);
        
        // Güncelleme verilerini hazırla
        const updateData = {
          table: this.table,
          ids: ids,
          fieldName: this.bulkForm.fieldName,
          fieldValue: this.bulkForm.fieldValue
        };
        
        // İkili atama varsa ekle
        if (this.bulkForm.doubleUpdate && this.bulkForm.fieldName2) {
          updateData.fieldName2 = this.bulkForm.fieldName2;
          updateData.fieldValue2 = this.bulkForm.fieldValue2;
          updateData.doubleUpdate = true;
        }

        // Notları gizleyerek ata seçiliyse ekle
        if (this.bulkForm.hide_notes) {
          updateData.hide_notes = true;
        }

        // Eşit dağıt: döngü önceki batch'lerin kaldığı yerden devam eder
        if (this.bulkDistribute && Object.keys(this.bulkDistribute).length) {
          updateData.distribute = this.bulkDistribute;
          updateData.distribute_offset = this.bulkDistributeOffset + processedCount;
        }
        
        // Bu batch'deki kayıtları güncelle
        return httpService.bulkSave(updateData).then((response) => {
          // İptal edildiyse devam etme
          if (this.bulkOperationCancelled) return;
          
          // Backend'den gelen yanıtı kontrol et
          if (response.data && response.data.success === false) {
            // Backend hatası durumunda işlemi durdur
            console.error("Backend hatası:", response.data.message);
            this.stopBulkOperation(`Güncelleme işlemi sırasında sunucu hatası: ${response.data.message || 'Bilinmeyen hata'}`, 'error');
            return;
          }

          if (response.data && response.data.distribution) {
            this.mergeDistributionSummary(this.bulkDistributeSummary, response.data.distribution);
          }
          
          // İşlenen toplam kayıt sayısını güncelle
          const newProcessedCount = processedCount + ids.length;
          
          // İlerlemeyi güncelle - toplam kayıt sayısına göre
          const progress = Math.min(Math.round((newProcessedCount / this.bulkOperationTotal) * 100), 99);
          this.bulkOperationProgress = progress;
          
          // Hala işlenecek sayfa var mı kontrol et
          if (ids.length === batchSize) { // Eğer bu sayfa tam doluysa, başka sayfa olabilir
            // Kısa bir gecikme ile sunucuyu aşırı yükleme
            setTimeout(() => {
              // Bu batch'in en küçük id'sinden devam et
              this.processBulkUpdate(Math.min(...ids), batchSize, newProcessedCount);
            }, 300);
          } else {
            // Son sayfaya ulaşıldı, işlem tamamlandı
            this.bulkOperationProgress = 100;
            this.stopBulkOperation(this.bulkUpdateDoneMessage(), 'success', true);
          }
        }).catch(error => {
          console.error("Güncelleme hatası:", error);
          this.stopBulkOperation('Güncelleme işlemi sırasında bir hata oluştu.', 'error');
        });
      } else {
        // Bu sayfada kayıt yoksa işlem tamamlandı
        if (processedCount > 0) {
          // Eğer önceden kayıtlar güncellendiyse başarılı mesajı göster
          this.bulkOperationProgress = 100;
          this.stopBulkOperation(this.bulkUpdateDoneMessage(), 'success', true);
        } else {
          // Hiç kayıt güncellendiyse uygun mesaj göster
          this.bulkOperationProgress = 100;
          this.stopBulkOperation('İşlem tamamlandı. Güncellenecek kayıt bulunamadı.');
        }
      }
    })
    .catch(error => {
      console.error("Sayfa verisi alınamadı:", error);
      this.stopBulkOperation('Sayfa verisi alınırken bir hata oluştu.', 'error');
    });
},

// stopBulkOperation metodunu güncelleme işlemi için uyarla
stopBulkOperation(message, status = 'success', isUpdate = false) {
  this.processingBulkOperation = false;
  this.bulkOperationCancelled = false; // İşlem bitince iptal bayrağını sıfırla
  this.loading = false; // Loading durumunu da sıfırla
  clearInterval(this.bulkOperationInterval);
  
  // İlerleme çubuğunu güncelle
  const progressContainer = document.getElementById('bulk-operation-progress');
  if (progressContainer) {
    let statusColor, statusIcon;
    
    if (status === 'success') {
      statusColor = 'bg-green-600';
      statusIcon = '<svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>';
    } else if (status === 'warning') {
      statusColor = 'bg-yellow-500';
      statusIcon = '<svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>';
    } else {
      statusColor = 'bg-red-600';
      statusIcon = '<svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>';
    }
    
    progressContainer.innerHTML = `
      <div class="container mx-auto px-4 py-3">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="flex-shrink-0 ${statusColor} p-1 rounded-full">
              ${statusIcon}
            </div>
            <div class="font-medium text-gray-800">${escapeHtml(message || 'İşlem tamamlandı')}</div>
          </div>
          <button onclick="this.parentNode.parentNode.parentNode.remove()" class="px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium text-gray-700 transition">
            Kapat
          </button>
        </div>
      </div>
    `;
    
    // 10 saniye sonra otomatik kapat
    setTimeout(() => {
      if (document.getElementById('bulk-operation-progress')) {
        document.getElementById('bulk-operation-progress').remove();
      }
    }, 10000);
  }
  
  // Verileri yenile (iptal edilmediyse)
  if (status !== 'warning') {
    // Formları temizle (güncelleme ise)
    if (isUpdate) {
      this.bulkForm = {}; // Formu temizle
      this.resetDistribution();
    }
    
    this.getData('bulkOperationCompleted');
  }
},

// startBulkOperation metodunu güncelleme işlemi içinde uyarla
startBulkOperation(type) {
  this.processingBulkOperation = true;
  this.bulkOperationProgress = 0;
  this.bulkOperationCancelled = false; // İşlem başlangıcında iptal bayrağını sıfırla
  
  // İşlem tipine göre mesaj belirle
  if (type === 'delete') {
    this.bulkOperationMessage = 'Kayıtlar siliniyor...';
  } else if (type === 'deleteNotes') {
    this.bulkOperationMessage = 'Notlar siliniyor...';
  } else if (type === 'update') {
    this.bulkOperationMessage = 'Kayıtlar güncelleniyor...';
  } else {
    this.bulkOperationMessage = 'İşlem devam ediyor...';
  }
  
  // Modern ilerleme çubuğu oluşturma
  const progressContainer = document.createElement('div');
  progressContainer.id = 'bulk-operation-progress';
  progressContainer.className = 'fixed top-0 left-0 right-0 z-50 bg-white shadow-lg border-b border-gray-200';
  
  progressContainer.innerHTML = `
    <div class="container mx-auto px-4 py-3">
      <div class="flex items-center justify-between mb-2">
        <div class="flex items-center">
          <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="font-medium text-gray-800">${this.bulkOperationMessage}</span>
        </div>
        <div class="flex items-center space-x-2">
          <span id="progress-text" class="text-sm font-semibold text-blue-600">0%</span>
          <button 
            id="cancel-operation-btn" 
            class="px-2 py-1 bg-red-100 hover:bg-red-200 text-red-700 text-xs font-medium rounded transition-colors duration-200"
          >
            İptal
          </button>
        </div>
      </div>
      <div class="w-full bg-gray-200 rounded-full h-2.5">
        <div id="progress-bar" class="bg-blue-600 h-2.5 rounded-full transition-all duration-300" style="width: 0%"></div>
      </div>
      <div class="text-xs text-gray-500 mt-1">Toplam: ${this.bulkOperationTotal} kayıt</div>
    </div>
  `;
  
  document.body.appendChild(progressContainer);
  
  // İptal butonuna event listener ekle
  document.getElementById('cancel-operation-btn').addEventListener('click', () => {
    this.cancelBulkOperation();
  });
  
  // İlerleme çubuğunu güncellemek için interval
  this.bulkOperationInterval = setInterval(() => {
    const progressBar = document.getElementById('progress-bar');
    const progressText = document.getElementById('progress-text');
    if (progressBar && progressText) {
      progressBar.style.width = `${this.bulkOperationProgress}%`;
      progressText.innerText = `${this.bulkOperationProgress}%`;
    }
  }, 100);
},
    bulkRemoveAll() {
  // Önce toplam kayıt sayısını al ve kullanıcıya göster
  this.loading = true;
  
  httpService
    .getData({
      table: this.table,
      filters: this.filters,
      countOnly: true
    })
    .then(response => {
      this.loading = false;
      
      if (response.data && response.data.total) {
        this.bulkOperationTotal = response.data.total;
        
        // Silme onay modalını göster
        this.showDeleteConfirmation('delete', response.data.total);
      } else {
        EventBus.$emit("bottomMessage", {
          open: true,
          type: "warning",
          title: "Uyarı",
          duration: 3000,
          body: "Silinecek kayıt bulunamadı.",
        });
      }
    })
    .catch(error => {
      this.loading = false;
      console.error("Kayıt sayısı alınamadı:", error);
      
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "error",
        title: "Hata",
        duration: 3000,
        body: "Toplam kayıt sayısı alınamadı.",
      });
    });
},

bulkRemoveAllNotes() {
  // Önce toplam kayıt sayısını al ve kullanıcıya göster
  this.loading = true;
  
  httpService
    .getData({
      table: this.table,
      filters: this.filters,
      countOnly: true
    })
    .then(response => {
      this.loading = false;
      
      if (response.data && response.data.total) {
        this.bulkOperationTotal = response.data.total;
        
        // Silme onay modalını göster
        this.showDeleteConfirmation('deleteNotes', response.data.total);
      } else {
        EventBus.$emit("bottomMessage", {
          open: true,
          type: "warning",
          title: "Uyarı",
          duration: 3000,
          body: "Silinecek not bulunamadı.",
        });
      }
    })
    .catch(error => {
      this.loading = false;
      console.error("Not sayısı alınamadı:", error);
      
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "error",
        title: "Hata",
        duration: 3000,
        body: "Toplam not sayısı alınamadı.",
      });
    });
},


showDeleteConfirmation(type, total) {
  // Modal HTML oluşturma
  const modalContainer = document.createElement('div');
  modalContainer.id = 'delete-confirmation-modal';
  modalContainer.className = 'fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50';
  
  const modalContent = document.createElement('div');
  modalContent.className = 'bg-white rounded-lg shadow-xl w-full max-w-md mx-4 overflow-hidden';
  
  // Modal içeriği
  const title = type === 'delete' ? 'Kayıtları Sil' : 'Notları Sil';
  const message = type === 'delete' 
    ? `Mevcut filtrelere göre toplam <strong>${total}</strong> kayıt silinecektir. Bu işlem geri alınamaz ve arka planda gerçekleştirilecektir.`
    : `Mevcut filtrelere göre toplam <strong>${total}</strong> not silinecektir. Bu işlem geri alınamaz ve arka planda gerçekleştirilecektir.`;
  
  modalContent.innerHTML = `
    <div class="p-6">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-medium text-gray-900">${title}</h3>
        <button id="modal-close" class="text-gray-400 hover:text-gray-500">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      <div class="text-sm text-gray-500 mb-4">
        ${message}
      </div>
      <div class="mt-6 flex justify-end space-x-3">
        <button id="modal-cancel" class="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
          İptal
        </button>
        <button id="modal-confirm" class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700">
          Sil
        </button>
      </div>
    </div>
  `;
  
  modalContainer.appendChild(modalContent);
  document.body.appendChild(modalContainer);
  
  // Modal butonlarına event listener ekle
  document.getElementById('modal-close').addEventListener('click', () => {
    document.getElementById('delete-confirmation-modal').remove();
  });
  
  document.getElementById('modal-cancel').addEventListener('click', () => {
    document.getElementById('delete-confirmation-modal').remove();
  });
  
  document.getElementById('modal-confirm').addEventListener('click', () => {
    document.getElementById('delete-confirmation-modal').remove();
    
    if (type === 'delete') {
      this.startBulkOperation('delete');
      this.processBulkDelete(1, 1000);
    } else {
      this.startBulkOperation('deleteNotes');
      this.processBulkDeleteNotes(1, 1000);
    }
  });
},
 

cancelBulkOperation() {
  if (!confirm('İşlemi iptal etmek istediğinize emin misiniz?')) {
    return;
  }
  
  this.bulkOperationCancelled = true;
  
  // İptal mesajını göster
  this.stopBulkOperation('İşlem kullanıcı tarafından iptal edildi.', 'warning');
},
 

    updateBulkProgress(processed) {
      const progress = Math.min(Math.round((processed / this.bulkOperationTotal) * 100), 100);
      this.bulkOperationProgress = progress;
    },

    processBulkDelete(page, batchSize) {
  // İptal edildiyse işlemi durdur
  if (!this.processingBulkOperation || this.bulkOperationCancelled) return;
  
  // Her zaman sayfa 1'i sor çünkü kayıtlar silindikçe diğer sayfalar öne kayıyor
  httpService
    .getData({
      table: this.table,
      page: 1,
      limit: batchSize,
      filters: this.filters,
      fields: ['id'] // Sadece ID'leri al
    })
    .then(response => {
      // İptal edildiyse devam etme
      if (this.bulkOperationCancelled) return;
      
      // Eğer silmek için kayıt varsa
      if (response.data && response.data.results && response.data.results.length > 0) {
        const ids = response.data.results.map(item => item.id);
        
        // İşlenen kayıt sayısını güncelle
        const processedSoFar = Math.min(
          page * batchSize,
          this.bulkOperationTotal
        );
        this.updateBulkProgress(processedSoFar);
        
        // Bu batch'i sil
        return httpService.bulkRemove({
          table: this.table,
          ids: ids
        }).then(() => {
          // İptal edildiyse devam etme
          if (this.bulkOperationCancelled) return;
          
          // Kalan kayıt sayısını kontrol et
          return httpService.getData({
            table: this.table,
            filters: this.filters,
            countOnly: true
          }).then(countResponse => {
            // İptal edildiyse devam etme
            if (this.bulkOperationCancelled) return;
            
            const remainingCount = countResponse.data.total;
            
            // Hala silinecek kayıt varsa (remainingCount > 0), 
            // rekürsif olarak tekrar çağır ve aynı işleme devam et
            if (remainingCount > 0) {
              // İlerlemeyi güncelle
              const newProgress = ((this.bulkOperationTotal - remainingCount) / this.bulkOperationTotal) * 100;
              this.bulkOperationProgress = Math.min(Math.round(newProgress), 99); // 100'e ulaşmadan önce dur
              
              // Kısa bir gecikme ile sunucuyu aşırı yükleme
              setTimeout(() => {
                // Sayfa numarasını artır - bu ilerleme hesabı için önemli
                this.processBulkDelete(page + 1, batchSize);
              }, 300);
            } else {
              // Tüm kayıtlar silindi, %100 ilerleme göster
              this.bulkOperationProgress = 100;
              this.stopBulkOperation('Tüm kayıtlar başarıyla silindi.');
            }
          }).catch(error => {
            console.error("Kalan kayıt sayısı alınamadı:", error);
            this.stopBulkOperation('İşlem tamamlanamadı. Lütfen listeyi yenileyin.', 'error');
          });
        }).catch(error => {
          console.error("Batch silme hatası:", error);
          this.stopBulkOperation('Silme işlemi sırasında bir hata oluştu.', 'error');
        });
      } else {
        // Eğer hiç kayıt bulunamadıysa
        if (page === 1) {
          // İlk sayfada hiç kayıt yoksa, işlem tamamlanmıştır
          this.bulkOperationProgress = 100;
          this.stopBulkOperation('İşlem tamamlandı. Silinecek kayıt kalmadı.');
        } else {
          // Diğer sayfalarda kayıt yoksa, önceki kayıtlar silinmiş olabilir
          // Bu durumda yeniden sayfa 1'i kontrol et
          this.bulkOperationProgress = 100;
          this.stopBulkOperation('Tüm kayıtlar başarıyla silindi.');
        }
      }
    })
    .catch(error => {
      console.error("Toplu silme hatası:", error);
      this.stopBulkOperation('Silme işlemi sırasında bir hata oluştu.', 'error');
    });
},


// Düzeltilmiş processBulkDeleteNotes fonksiyonu - sayfa sayfa ilerleyerek
processBulkDeleteNotes(page, batchSize, processedCount = 0) {
  // İptal edildiyse işlemi durdur
  if (!this.processingBulkOperation || this.bulkOperationCancelled) return;
  
  // Belirli sayfadaki kayıtları getir (sayfa numarası parametreden gelir)
  httpService
    .getData({
      table: this.table,
      page: page, // Her seferinde sayfa numarasını artırarak ilerle
      limit: batchSize,
      filters: this.filters,
      fields: ['id'] // Sadece ID'leri al
    })
    .then(response => {
      // İptal edildiyse devam etme
      if (this.bulkOperationCancelled) return;
      
      // Eğer bu sayfada kayıt varsa
      if (response.data && response.data.results && response.data.results.length > 0) {
        const ids = response.data.results.map(item => item.id);
        
        // Bu batch'deki kayıtların notlarını sil
        return httpService.bulkRemoveNotes({
          table: this.table,
          ids: ids
        }).then(() => {
          // İptal edildiyse devam etme
          if (this.bulkOperationCancelled) return;
          
          // İşlenen toplam kayıt sayısını güncelle
          const newProcessedCount = processedCount + ids.length;
          
          // İlerlemeyi güncelle - toplam kayıt sayısına göre
          const progress = Math.min(Math.round((newProcessedCount / this.bulkOperationTotal) * 100), 99);
          this.bulkOperationProgress = progress;
          
          // Hala işlenecek sayfa var mı kontrol et
          if (ids.length === batchSize) { // Eğer bu sayfa tam doluysa, başka sayfa olabilir
            // Kısa bir gecikme ile sunucuyu aşırı yükleme
            setTimeout(() => {
              // Bir sonraki sayfaya geç
              this.processBulkDeleteNotes(page + 1, batchSize, newProcessedCount);
            }, 300);
          } else {
            // Son sayfaya ulaşıldı, işlem tamamlandı
            this.bulkOperationProgress = 100;
            this.stopBulkOperation('Tüm notlar başarıyla silindi.');
          }
        }).catch(error => {
          console.error("Not silme hatası:", error);
          this.stopBulkOperation('Not silme işlemi sırasında bir hata oluştu.', 'error');
        });
      } else {
        // Bu sayfada kayıt yoksa işlem tamamlandı
        if (processedCount > 0) {
          // Eğer önceden notlar silindiyse başarılı mesajı göster
          this.bulkOperationProgress = 100;
          this.stopBulkOperation('Tüm notlar başarıyla silindi.');
        } else {
          // Hiç not silinmediyse uygun mesaj göster
          this.bulkOperationProgress = 100;
          this.stopBulkOperation('İşlem tamamlandı. Silinecek not bulunamadı.');
        }
      }
    })
    .catch(error => {
      console.error("Sayfa verisi alınamadı:", error);
      this.stopBulkOperation('Sayfa verisi alınırken bir hata oluştu.', 'error');
    });
},
    multiFilterFormValue(name) {
      if (name) {
        return Object.values(this.filters).find((e) => e.name == name);
      }
      return null;
    },
    multiFilterFormAdd(value, name) {
      this.multiFilterItem[name] = value;
    },
    localStorageGet() {
      if (this.$root.isMobile()) {
        if (this.table == "leads" || this.table == "customers") {
          this.allFieldsCheckbox = ["id", "name"];
        }
      } else {
        if (localStorage.getItem(this.table + "_allFieldsCheckbox")) {
          let ids = localStorage.getItem(this.table + "_allFieldsCheckbox");
          if (ids.substring(0, 3) == "id,") {
            // Do nothing - leave ids as is
          } else {
            ids = "id," + ids;
          }
          this.allFieldsCheckbox = ids.split(",");
        } else {
          if (this.table == "leads" || this.table == "customers") {
            this.allFieldsCheckbox = [
              "id",
              "name",
              "status_id",
              "agent_id",
              "utm_source",
              "team_id",
            ];
          } else {
            this.allFieldsCheckbox = [];
          }
        }
      }
      if (localStorage.getItem(this.table + "_sortType")) {
        this.sort.type = localStorage.getItem(this.table + "_sortType");
        this.sort.name = localStorage.getItem(this.table + "_sortName");
      } else {
        //console.log("bulunamadı");
      }
    },
    filterRemove(item) {
      this.filters.splice(this.filters.indexOf(item), 1);
      this.getData("filterRemove");
    },
    addFilters() {
      if (this.filterForm.value) {
        if (this.filterForm.editedId) {
          this.filters.splice(this.filterForm.editedId - 1, 1);
        }

        this.filters.push(this.filterForm);
        this.filterForm = {
          name: "",
          type: "",
          value: "",
        };
        this.getData("addFilters");
      }
    },
    filterEdit(item) {
      this.filterToEdit = item;
      this.filterForm = { ...item };
      this.filterForm.editedId = this.filters.indexOf(item) + 1;
      //   this.filters.splice(this.filters.indexOf(item), 1);
    },
    fieldConfigOpen() {
      this.fieldConfig = true;
      if (!this.allFieldsCheckbox) {
        this.allFieldsCheckbox = [];
        Object.values(this.allFields).forEach((field) => {
          if (this.tableHead[field]) {
            this.allFieldsCheckbox.push(field);
          }
        });
      }
    },
    getData(methodName) {
      EventBus.$emit("loadingStatus", {
        action: methodName,
        loading: true,
      });

      this.$forceUpdate();

      this.loading = true;

      // Update URL with current filters, pagination and sorting
      if (methodName !== 'created' && methodName !== 'watch') {
        const urlBuild = new URL(
          window.location.origin + window.location.pathname
        );
        
        // Add page to query params
        if (this.page > 1) {
          urlBuild.searchParams.append('page', this.page);
        }
        
        // Add limit to query params
        if (this.limit !== 15) {
          urlBuild.searchParams.append('limit', this.limit);
        }
        
        // Add sorting to query params
        if (this.sort && this.sort.name) {
          urlBuild.searchParams.append('sort_by', this.sort.name);
          urlBuild.searchParams.append('sort_type', this.sort.type);
        }
        
        // Add filters to query params
        this.filters.forEach((filter, index) => {
          if (filter.name && filter.value) {
            // For simple filters
            if (typeof filter.value === 'string' || typeof filter.value === 'number') {
              urlBuild.searchParams.append(`filter_${index}_name`, filter.name);
              urlBuild.searchParams.append(`filter_${index}_type`, filter.type);
              urlBuild.searchParams.append(`filter_${index}_value`, filter.value);
            } 
            // For complex filters like between dates
            else if (typeof filter.value === 'object') {
              urlBuild.searchParams.append(`filter_${index}_name`, filter.name);
              urlBuild.searchParams.append(`filter_${index}_type`, filter.type);
              
              if (filter.type === 10 && filter.value.start && filter.value.end) {
                urlBuild.searchParams.append(`filter_${index}_value_start`, filter.value.start);
                urlBuild.searchParams.append(`filter_${index}_value_end`, filter.value.end);
              } else if (Array.isArray(filter.value)) {
                // For array values (multiple selection filters)
                filter.value.forEach((val, valIndex) => {
                  urlBuild.searchParams.append(`filter_${index}_value_${valIndex}`, val);
                });
              }
            }
          }
        });
        
        // Update browser history without reloading the page
        history.pushState({}, '', urlBuild.href);
      }

      return httpService
        .getData({
          table: this.table,
          page: this.page,
          sort: this.sort,
          filters: this.filters,
          limit: this.limit,
          fields: this.allFieldsCheckbox,
        })
        .then((response) => {
          this.fields = response.data.components;

          this.fields.map((field) => {
            this.fieldsMap[field.name] = field;
          });

          if (this.table == response.data.table) {
            this.tableData = response.data.results;
            this.total = 1 * response.data.total;
            if (response.data.page) {
              if (response.data.page > 0) {
                this.page = 1 * response.data.page + 1;
              } else {
                this.page = 0;
              }
            }
            EventBus.$emit("loadingStatus", {
              action: methodName,
              loading: false,
              success: true,
            });

            this.tableHead = response.data.fields;
            this.allFields = response.data.all_fields;
            this.tabId = response.data.tab_field_id;
            setTimeout(() => {
              this.loading = false;
            }, 100);
          } else {
            this.loading = true;
            this.tableData = this.allFields = this.tableHead = [];
          }
        })
        .catch(() => {
          console.log("yarıda kesildi");
        });
    },
    selectAll(checkboxs) {
      this.select_all = !this.select_all;
      if (this.select_all == true) {
        checkboxs.forEach((item) => {
          this.selection.push(item.id);
        });
      } else {
        this.selection = [];
      }
    },
    setSort(a) {
      this.sortType = a;
    },
    defaultSortSet() {
      localStorage.setItem(this.table + "_sortType", this.sort.type);
      localStorage.setItem(this.table + "_sortName", this.sort.name);
      this.getData("setSortItem");
    },
    setSortItem(a) {
      if (this.sort.type == "asc") {
        this.sort.type = "desc";
      } else {
        this.sort.type = "asc";
      }
      this.sort.name = a;

      this.getData("setSortItem");
    },
    // Lead kartında kaydedilen satırı listeyi yeniden çekmeden günceller.
    // Sadece satırda zaten olan (listede görünen) alanlar değiştirilir.
    onLeadSaved(data) {
      if (!data || !data.results || !["leads", "customers"].includes(this.table)) {
        return;
      }
      const index = this.tableData.findIndex(
        (row) => String(row.id) === String(data.id)
      );
      if (index === -1) {
        return;
      }
      const row = Object.assign({}, this.tableData[index]);
      Object.keys(row).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(data.results, key)) {
          row[key] = data.results[key];
        }
      });
      this.$set(this.tableData, index, row);
      this.$set(
        this.rowRevisions,
        row.id,
        (this.rowRevisions[row.id] || 0) + 1
      );
    },
    onQuickViewActive(data) {
      this.quickViewActiveId = data && data.id ? String(data.id) : null;
    },
    onQuickViewClosed(data) {
      this.onQuickViewActive(data);
      // Kapatınca son bakılan satır görünür kalsın, liste oradan devam etsin
      this.$nextTick(() => {
        if (!this.quickViewActiveId || !this.$el.querySelector) {
          return;
        }
        const row = this.$el.querySelector(
          '[data-row-id="' + this.quickViewActiveId + '"]'
        );
        if (row) {
          row.scrollIntoView({ block: "nearest" });
        }
      });
    },
    onPageChange() {
      this.getData('pageupdate');
    },
  },
  beforeDestroy() {
    EventBus.$off("leadQuickViewActive", this.onQuickViewActive);
    EventBus.$off("leadQuickViewClosed", this.onQuickViewClosed);
    EventBus.$off("leadSaved", this.onLeadSaved);
  },
  mounted() {
    this.localStorageGet();

    EventBus.$on("leadQuickViewActive", this.onQuickViewActive);
    EventBus.$on("leadQuickViewClosed", this.onQuickViewClosed);
    EventBus.$on("leadSaved", this.onLeadSaved);

    EventBus.$on("reflesh", () => {
      this.modalEditShow = false;
      this.modalPermissionShow = false;
      this.leadDetailModal = false;
      this.getData("reflesh");
    });
    EventBus.$on("favoriteFilterApply", (data) => {
      this.modalEditShow = false;
      this.modalPermissionShow = false;
      this.leadDetailModal = false;
      this.favoriteFilterApply(JSON.parse(data));
    });

    EventBus.$on("modalClose", () => {
      this.modalEditShow = false;
      this.modalPermissionShow = false;
      this.leadDetailModal = false;
    });
    EventBus.$on("editModalShow", (data) => {
      this.modalEdit.table = data.table;
      this.modalEdit.id = data.id;
      this.modalEditShow = true;
    });
    EventBus.$on("modalPermissionShow", (data) => {
      this.modalEdit.table = data.table;
      this.modalEdit.id = data.id;
      this.modalPermissionShow = true;
    });
    EventBus.$on("leadDetailModalShow", (data) => {
      this.modalEdit.id = data.id;
      this.leadDetailModal = true;
    });
  },
};
</script>

<style scoped>
.quickview-row-active td {
  @apply bg-tile-50;
}

.quickview-row-active td:first-child {
  box-shadow: inset 3px 0 0 #e16741;
}

.filter-item:hover .filter-close {
  @apply text-red-500;
}

.filter-item:hover .filter-edit {
  @apply text-blue-500;
}

.table-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f54a;
}

.table-scroll::-webkit-scrollbar {
  height: 4px;
  width: 4px;
  background-color: #f5f5f54a;
}

.table-scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #fff;
}

.thead-item {
  cursor: pointer;
  padding: 4px 10px !important;
  text-overflow: ellipsis;
}
.thead-item:hover {
  @apply bg-pampas;
}

.thead-item {
  @apply align-middle truncate;
}

.navclass {
  margin-top: 15px;
  display: block;
}

.filtre-form {
  margin: 0px !important;
  padding-top: 10px;
}

.filters-ul {
  display: block;
  margin: 0px;
  padding: 0px;
}

.filters-ul .filter-label {
  font-size: 11px;
  display: block;
  clear: both;
  color: #ccc;
}

.filters-ul .filter-label:hover {
  color: #222;
}

.filters-ul li {
  display: block;
  border-bottom: 1px solid #eee;
  margin-bottom: 2px;
  min-height: 45px;
  padding: 3px;
}

.filters-ul li b {
  display: block;
  font-size: 11px;
  font-weight: normal;
  float: left;
}

.filters-ul .uk-icon {
  cursor: pointer;
}

.field-labels label {
  display: block;
  padding: 5px;
}

.table-name {
  margin-top: 20px;
}

.drag {
  padding: 10px;
  cursor: pointer;
}

.add-item-button {
  cursor: copy;
}

.table-header-nav {
  margin: 0px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  padding: 0px;
  align-items: center;
}

.table-header-nav .excel-import-li {
  align-self: flex-end;
  order: 7;
}

.table-header-nav li {
  display: block;
  align-items: flex-end;

  padding: 5px;
}

.table-header-nav li a {
  color: #222;
  display: block;
  padding: 10px;
  font-size: 12px;
}

.heightoverflow {
}

.total-records {
  margin: 0px;
  padding: 0px;
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 13px;
  color: #999;
  text-transform: uppercase;
}

.filter-close {
  float: right;
}

.flex-row {
  display: flex;
  flex-direction: row;
  margin-left: -15px;
}

.selectedTr {
  background: #f7f8fb;
}

.table-toolbar .global-button {
  @apply whitespace-nowrap;
}
.bulk-bar {
  @apply flex flex-wrap items-center gap-2 mt-3 px-3 py-2 rounded-lg border border-gray-200 bg-gray-50;
}
.bulk-bar-count {
  @apply text-sm text-gray-600 whitespace-nowrap pr-2 mr-1 border-r border-gray-300;
}
.bulk-bar-count strong {
  @apply text-gray-900;
}
.bulk-bar-select {
  width: auto !important;
  min-width: 140px;
  max-width: 220px;
}
.bulk-field {
  @apply flex flex-wrap items-center gap-2 p-1 rounded-lg bg-white border border-gray-200;
}
.bulk-checks {
  @apply flex items-center gap-3 text-sm text-gray-700 px-1;
}
.bulk-checks label {
  @apply flex items-center gap-1 whitespace-nowrap cursor-pointer;
}
.bulk-checks .uk-checkbox {
  margin-top: 0;
}
.bulk-actions {
  @apply flex flex-wrap items-center gap-2 ml-auto;
}
.assign-mode {
  @apply inline-flex rounded-lg ring-1 ring-inset ring-gray-300 overflow-hidden text-sm flex-shrink-0;
  height: 32px;
}
.assign-mode button {
  @apply px-3 text-gray-600 bg-white transition-colors whitespace-nowrap;
}
.assign-mode button + button {
  @apply border-l border-gray-300;
}
.assign-mode button:hover {
  @apply bg-gray-100;
}
.assign-mode button.active {
  @apply bg-gray-900 text-white;
}
.w-overflow {
  @apply w-full overflow-x-scroll;
}
</style>
